export default {
  state: {
    isChange: 0    // 个人信息key
  },
  mutations: {
    set_isChange (state, val) {
      state.isChange = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/useData.js